// extracted by mini-css-extract-plugin
module.exports = {"radioButtonBlock":"RadioButton_radioButtonBlock__3XgDK","iconBlock":"RadioButton_iconBlock__1pjl5","label":"RadioButton_label__oLlvb"};